namespace $.$$ {

	/** Устройство пользователя с пуш-токеном. */
	export class $bog_gram_device extends $giper_baza_dict.with({
		Title: $giper_baza_atom_text,
		Token: $giper_baza_atom_text,
	}) {}

}
